import { Component, Inject } from '@angular/core';
import { StateService } from "@uirouter/angular";
import { CompetenceGroupsService } from "../../core/competencegroups.dataservice";
import { MatDialog } from "@angular/material/dialog";
import { DetailsBase } from "../shared/details.base";

@Component({
    selector: "crew-competencegroup",
    template: require('../shared/details-view.html')
})
export class CompetenceGroup extends DetailsBase<Nema.Crew.Model.CompetenceGroup> {
    constructor(
        stateService: StateService,
        dialog: MatDialog,
        @Inject('competencegroup') competencegroup: Nema.Crew.Model.CompetenceGroup,
        @Inject('competenceGroupsService') competenceGroupsService: CompetenceGroupsService,
        @Inject('$log') $log: ng.ILogService) {

        super(stateService, dialog, competencegroup, competenceGroupsService, $log);
    }

    public entityName = "Competence Group";

    public editStateName = "app.settings.competencegroups.edit";

    public listStateName = "app.settings.competencegroups";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/competencegroups/competencegroup.component.ts